<template>
  <div class="side-wrapper box box_v">
    <div class="top flexbt box">
      <div>
        <span class="iconfont icon-top icon-shaixuan1"></span>
        <span>筛选</span>
      </div>
      <div @click="initRight">
        <span class="iconfont icon-top icon-zhongzhi"></span>
        <span>重置</span>
      </div>
    </div>
    <div class="name-wrapper box">
      <div class="name">姓名</div>
      <div class="name-search">
        <Input search placeholder="请输入..." v-model="inputName" @on-search="changeName" />
      </div>
    </div>

    <Collapse simple  class="box box_f1 flcollapse">
      <Panel name="1">
        分类
        <div slot="content" class="fenlei">

          <div class="fenlei-list flexbt" :class="{red:item.isSelect}" v-for="(item, index) in labelList" :key="index" @click="changeSelect(index)">
            <div class="item-left" >
              <div v-if="!item.isSelect" class="iconfont icon-duoxuankuang1 weixuanzhong"></div>
              <div v-else="item.isSelect" class="iconfont icon-duoxuan1 xuanzhong"></div>
              <div class="fenlei-item">{{item.zoneName}}</div>
            </div>
            <div class="item-right">
              {{item.userCount}}
            </div>
          </div>
        </div>
      </Panel>
    </Collapse>

    <!--<div class="fenlei-wrapper">-->
      <!--<div class="fenlei-head flexbt">-->
        <!--<div class="fenlei">分类</div>-->
        <!--<div class="iconfont icon-up xia"></div>-->
      <!--</div>-->
      <!--<div class="list-wrapper">-->
        <!--<div class="fenlei-list flexbt" v-for="(item, index) in fenleiList" :key="index">-->
          <!--<div class="item-left" >-->
            <!--<div class="iconfont icon-xuanze1 xuanze"></div>-->
            <!--<div class="fenlei-item">{{item.name}}</div>-->
          <!--</div>-->
          <!--<div class="item-right">-->
            <!--{{item.number}}-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
  var that;
  export default {
    name: 'rightSide',
    components: {
    },
    props:{
      labelList: Array
    },
    data () {
      return {
        inputName:'',//输入框value
      }
    },
    methods: {
      changeSelect (index) {
        that.$emit('changeSelect',index,that.inputName)
      },
      changeName () {
        console.log('搜索')
        that.$emit('nameSelect',that.inputName)
      },
      initRight () {
        console.log('重置')
        that.inputName = ''
        that.$emit('initRight')
      }
    },
    created () {
      that = this
    }
  }
</script>

<style scoped>
  .flexbt{
    display: flex;
    justify-content: space-between;
  }
  .side-wrapper{
    width: 260px;

    border-left: 1px solid #ddd;
    background: #fff;
    position: fixed;
    top:60px;
    right: 0;
    bottom: 0;

  }
  .top{
    color: #677b9e;
    padding: 20px 25px;
    border-bottom: 1px solid #dedede
  }
  .name-wrapper{
    padding: 30px 20px;
    align-items: center
  }
  /*.name-search{*/
    /*padding: 2px 5px;*/
    /*border: 1px solid #c7c7c7;*/
    /*border-radius: 20px;*/
    /*height: 35px;*/
    /*line-height: 35px;*/
  /*}*/
  .name{
    color:#4b4b4b;
    margin-right: 10px
  }
  .name-search{
    position: relative;
  }
  input{
    font-size: 15px;
    padding-left:10px;
    height:35px;
    width: 220px;
    border-radius:20px;
    border:1px solid #c7c7c7;
    color:#666;
    /*outline:0;*/
    display:block;
    background: #f1f1f1;
  }
  .sousuo{
    color: #9a9a9a;
    font-size:20px;
    position:absolute;
    right:10px;
    top:2px
  }
  .fenlei-wrapper{
    padding:0 20px;
    color: #4b4b4b
  }
  .fenlei-head{
    padding-bottom: 20px
  }
  .fenlei{
  }
  .fenlei-list{
    font-size:13px;
    padding-left: 15px;
    padding-bottom: 10px;
    width: 220px;
  }
  .fenlei-list:last-child{
    padding-bottom: 0;
  }
  .item-left{
    display:flex;
  }
  .xia{
    color: #9a9a9a
  }
  .weixuanzhong{
    font-size: 16px;
    padding-right: 10px;
  }
  .xuanzhong{
    font-size: 16px;
    padding-right: 10px;
  }
.flcollapse{
  width: 260px;
  overflow: scroll;

}
.flcollapse::-webkit-scrollbar{
  width:0px;
}
</style>
